import { Record } from "./fable_modules/fable-library.3.7.20/Types.js";
import { record_type, list_type, int32_type, bool_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";

export class FeeConfig extends Record {
    constructor(OneTime, Monthly, MonthlyDate, MonthlyWith3MonthsInvoice, MonthlyWith6MonthsInvoice, MonthlyWith12MonthsInvoice, QuarterlyDate, HalfYearDate, YearlyDate, PerInvoice, DefaultMonthsInAdvance, DefaultCancellationPeriodMonths, UsesUnitPrice) {
        super();
        this.OneTime = OneTime;
        this.Monthly = Monthly;
        this.MonthlyDate = MonthlyDate;
        this.MonthlyWith3MonthsInvoice = MonthlyWith3MonthsInvoice;
        this.MonthlyWith6MonthsInvoice = MonthlyWith6MonthsInvoice;
        this.MonthlyWith12MonthsInvoice = MonthlyWith12MonthsInvoice;
        this.QuarterlyDate = QuarterlyDate;
        this.HalfYearDate = HalfYearDate;
        this.YearlyDate = YearlyDate;
        this.PerInvoice = PerInvoice;
        this.DefaultMonthsInAdvance = DefaultMonthsInAdvance;
        this.DefaultCancellationPeriodMonths = DefaultCancellationPeriodMonths;
        this.UsesUnitPrice = UsesUnitPrice;
    }
}

export function FeeConfig$reflection() {
    return record_type("GlobalTypes.FeeConfig", [], FeeConfig, () => [["OneTime", bool_type], ["Monthly", bool_type], ["MonthlyDate", bool_type], ["MonthlyWith3MonthsInvoice", bool_type], ["MonthlyWith6MonthsInvoice", bool_type], ["MonthlyWith12MonthsInvoice", bool_type], ["QuarterlyDate", bool_type], ["HalfYearDate", bool_type], ["YearlyDate", bool_type], ["PerInvoice", bool_type], ["DefaultMonthsInAdvance", list_type(int32_type)], ["DefaultCancellationPeriodMonths", list_type(int32_type)], ["UsesUnitPrice", bool_type]]);
}

